module.exports = __webpack_public_path__ + "static/headshot-5a9ea5875a41a130a0ff7cc573b0e363.jpeg";